"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapCreateRouter = wrapCreateRouter;
const startReactRouterView_1 = require("./startReactRouterView");
function wrapCreateRouter(originalCreateRouter) {
    return ((routes, options) => {
        const router = originalCreateRouter(routes, options);
        let location = router.state.location.pathname;
        router.subscribe((routerState) => {
            const newPathname = routerState.location.pathname;
            if (location !== newPathname) {
                (0, startReactRouterView_1.startReactRouterView)(routerState.matches);
                location = newPathname;
            }
        });
        (0, startReactRouterView_1.startReactRouterView)(router.state.matches);
        return router;
    });
}
//# sourceMappingURL=createRouter.js.map